const apiUrlFallbackLocal = 'http://localhost:3000/dev';
export const API_URL = process.env.VUE_APP_API_URL || apiUrlFallbackLocal;
export const API_URL_DASHBOARDS = process.env.VUE_APP_API_URL_DASHBOARDS;
export const isDevelopmentEnv: boolean = process.env.NODE_ENV === 'development';
